import TradeExceptionTable from "./TradeExceptionTable";

export default TradeExceptionTable;
